export const SELECTION = null;
export const OPTION = '0';
export const BLOQUE = '1';
export const SANS_SUITE = '2';
export const ANNULATION = '3';



// WEBPACK FOOTER //
// ./src/configuration/optionConf.js